export const RectangleScadaIcon = () => (
  <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.75"
      y="0.75"
      width="45.5"
      height="45.5"
      fill="#F5F5F5"
      stroke="#8C969B"
      strokeWidth="1.5"
    />
  </svg>
);
